'use strict';

(function ($) {
    $.agito = $.agito || {};
    $.agito.dialogHelper = $.agito.dialogHelper || {};

    $.ajaxSetup({ cache: false });

    $.agito.dialogHelper.loadData = async function (dialogSelector, url, callback, hidden, data) {
        if (!hidden) {
            hidden = false;
        }
        var $dialog = $(dialogSelector).filter('.modal');
        var $content = $dialog.find('.modal-content');
        $content.empty();

        $content = $dialog.find('.modal-content');

        // lock body to prevent further clicking while dialog is loading
        document.body.inert = true;

        // wait for agApp to be ready first
        try {
            await window.agApp;
        }
        catch {
            document.body.inert = false;
        }
        
        $content.load(url, data, function (r, s, x) {
            document.body.inert = false;

            var sessionExpired = AjaxHelpers.HandleExpiredSession(x);
            if (!hidden && !sessionExpired) {
                // show dialog
                window.agApp.openLegacyDialog($dialog[0]);
            }
            else if (sessionExpired) {
                return;
            }

            // initialize controls inside dialog
            if ($.agito.igHelper) {
                $.agito.igHelper.initializeIgEditors(dialogSelector);
            }
            if ($.agito.controlsHelper) {
                $.agito.controlsHelper.initializeAgitoControls(dialogSelector);
            }

            if (!($.agito.isMobileDevice || $.agito.isMobileApp)) {
                // set focus
                if ($.agito.utilities && $.agito.utilities.setFocus) {
                    $dialog.one('loaded.ag.modal', function () {
                        $.agito.utilities.setFocus($dialog.find('div.modal-body'));
                        if ($dialog.find(':focus').length === 0) {
                            $.agito.utilities.setFocus($dialog.find('div.modal-header'));
                        }
                    });
                }
            }

            // parse form
            if ($.validator && $.validator.unobtrusive) {
                $.validator.unobtrusive.parse(dialogSelector);
            }

            $dialog.trigger('loaded.ag.modal');

            if (callback) {
                callback($dialog);
            }

            return $dialog;
        });
    };

    $.agito.dialogHelper.closeDialog = function (dialogSelector, triggerSuccessCallback ) {

        if (triggerSuccessCallback && $(dialogSelector).filter('.modal').data('callback') != null) {
            $(dialogSelector).filter('.modal').data('callback')();
        }

        $(dialogSelector).filter('.modal').modal('hide');
    };

    $.agito.dialogHelper.draggableDialog = function (dialogSelector) {
        $(dialogSelector).filter('.modal').draggable({
            handle: ".modal-header"
        });
    };

    $.agito.dialogHelper.submitForm = function (dialogSelector, reloadOnSuccess, successCallback, failureCallback) {

        var $dialog = $(dialogSelector).filter('.modal');
        var $form = $dialog.find('form');
        var button = $dialog.find('.btn-submit');
        if (!$form.valid()) {
            $(button).prop('disabled', false);
            return;
        };

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',

            data: new FormData($form[0]),
            cache: false,
            contentType: false,
            processData: false
        })
            .done(function (data) {

                $(button).prop('disabled', false);

                if (data != null && data.hasOwnProperty('success')) {
                    if (!data.success) {

                        var messagesPlaceholder = $dialog.find('.hrm-page-messages-placeholder');

                        if (messagesPlaceholder.length > 0)
                            $.agito.hrmPage.handleAjaxError(messagesPlaceholder, data);
                        else
                            alert(data.message);

                        return;
                    }
                    else if (typeof data.message != "undefined") {
                        var messagesPlaceholder = $('.hrm-page-placeholder .hrm-page-messages-placeholder').first();

                        if (messagesPlaceholder.length > 0)
                            $.agito.hrmPage.handleAjaxError(messagesPlaceholder, data);
                        else
                            alert(data.message);
                    }
                    else
                    {
                        if (data.userMessages) {
                            var filtered = data.userMessages.filter(function (value) {
                                return value.persisted;
                            });

                            if (filtered.length > 0) {
                                $.agito.hrmPage.handleAjaxError($('.hrm-page-messages-placeholder:first'), filtered, false);
                            }
                        }
                    }
                }

                $(window).trigger('ag.data.changed');

                $dialog.modal('hide');
                if ($.isFunction(successCallback)) {
                    successCallback.call(this, data);
                }
                if (!!reloadOnSuccess) {
                    window.location.href = window.location.href;
                }
            }).fail($.isFunction(failureCallback) ? failureCallback : function (jqXHR, textStatus) {
                // TODO translate
                //var msg = 'Error has occured: ';
                //alert(msg + jqXHR.status + " " + jqXHR.statusText);
            });
    };
})($);